<template>
  <div id="app" class="classroom-wrapper">
    <NewBanner ref="banner" />

    <Nav :lists="navLists" :recommend_activity="recommend_activity" />

    <div class="classroom-innerWrapper">
      <!-- 推荐视频 -->
      <BlockArea
        :title="jingxuanTitle"
        :resource="jingxuanResource"
        :resourceId="jingxuanResourceId"
        :spmidfrom="SPM_ID_FROM_RECOMMEND"
        row="1"
        id="classroom-pick"
        v-if="jingxuanResource.length"
        v-reportShow="{
          module: 'select_lecture',
        }"
      />

      <div class="classroom-rec">
        <BlockArea
          :title="cheeseTitle"
          :transform="true"
          class="classroom-rec-content"
          :resourceId="cheeseResourceId"
          :resource="cheeseResource"
          id="classroom-rec"
          :skew="0"
          :spmidfrom="SPM_ID_FROM_NEWSEASON"
          v-reportShow="{
            module: 'new_lecture',
          }"
        />
        <RankList
          :data="rank"
          v-if="rank && rank.items && rank.items.length"
          v-reportShow="{
            module: 'hot_selling',
          }"
        />
      </div>

      <UpComming
        :data="timeline"
        v-if="timeline.length"
        v-reportShow="{
          module: 'lecture_preview',
        }"
      />
      <!-- 更多好课 -->
      <BlockArea
        :title="moreSeasonTitle"
        :resource="moreSeasonResource"
        :resourceId="moreSeasonResourceId"
        :spmidfrom="SPM_ID_FROM_MORESEASON"
        row="1"
        id="more-season"
        v-if="moreSeasonResource.length"
        v-reportShow="{
          module: 'select_lecture',
        }"
      />

      <BlockAreaV2
        :title="item.name"
        :resource="item.card_list"
        :resourceId="item.id"
        :subs="item.sub_list"
        :id="'cheese_resource_' + item.id"
        :transform="true"
        :spmidfrom="SPM_ID_FROM_RESOURCE"
        v-for="(item, index) in resource"
        :key="index"
      />

      <BackTopBar
        :visibilityHeight="visibilityHeight"
        :cooperationLink="cooperationLink"
      />
    </div>
  </div>
</template>

<script>
import './styles/common.less'
import { FETCH_LOGIN } from 'g-public/vuex/types'
import BackTopBar from './components/BackTopBar'
import BlockArea from './components/BlockArea'
import BlockAreaV2 from './components/BlockAreaV2'
import RankList from './components/RankList'
import UpComming from './components/UpComming'
import NewBanner from './components/NewBanner'
import Nav from './components/Nav'
import { FETCH_BANNER } from './vuex/types'
import http from 'g-public/apis/http'
import { isSentryMainFieldLoss } from 'g-public/utils/sentry'
import {
  SPM_ID_FROM_RECOMMEND,
  SPM_ID_FROM_RESOURCE,
  SPM_ID_FROM_NEWSEASON,
  SPM_ID_FROM_MORESEASON,
} from './enum'
import { reportPv } from 'g-public/report/index'

export default {
  name: 'cheese',
  components: {
    BackTopBar,
    BlockArea,
    RankList,
    UpComming,
    // Banner,
    NewBanner,
    Nav,
    BlockAreaV2,
  },
  asyncData({ store, route, context }) {
    return store.dispatch({
      type: FETCH_BANNER,
      headers: context.headers,
    })
  },

  beforeMount() {
    this.$store.dispatch({
      type: FETCH_LOGIN,
    })
  },

  data() {
    return {
      SPM_ID_FROM_RECOMMEND,
      SPM_ID_FROM_RESOURCE,
      SPM_ID_FROM_NEWSEASON,
      SPM_ID_FROM_MORESEASON,

      // 合作申请链接
      cooperationLink: '',

      // 回到顶部触发高度
      visibilityHeight: 0,

      componentMap: {},
      navLists: [],
      // 即将上线 时间轴
      timeline: [],
      // 推荐活动
      recommend_activity: {},
      // 排行榜
      rank: {},
      // 资源
      resource: [],
      // 精选推荐
      jingxuanResource: [],
      jingxuanResourceId: '',
      jingxuanTitle: '',
      // 新课推荐
      cheeseResource: [],
      cheeseResourceId: '',
      cheeseTitle: '',
      // 更多好课
      moreSeasonResource: [],
      moreSeasonResourceId: '',
      moreSeasonTitle: '',
    }
  },
  computed: {
    // ...mapState(['loginInfo'])
  },
  watch: {},
  mounted() {
    this.mainFieldReport()
    this.fetchData()
    this.visibilityHeight = this.$refs.banner.$el.offsetHeight + 56
    reportPv()
  },
  methods: {
    fetchData() {
      http.get('pugv/app/web/v2/zone').then(response => {
        if (response.status === 200 && response.data.code === 0) {
          const data = response.data.data

          // eslint-disable-next-line camelcase
          const {
            rank,
            timeline,
            recommend_activity,
            new_season,
            boutique_season,
            navigation_bar,
            classification_list,
            more_season,
          } = data
          if (
            !isSentryMainFieldLoss(rank, '排行榜字段rank异常', {
              response: response.data,
            })
          ) {
            this.rank = rank
          }

          // eslint-disable-next-line camelcase
          if (
            !isSentryMainFieldLoss(
                navigation_bar,
                '导航栏字段navigation_bar异常',
                {
                  response: response.data,
                },
            )
          ) {
            // eslint-disable-next-line camelcase
            this.navLists = navigation_bar
          }
          // eslint-disable-next-line camelcase
          if (
            !isSentryMainFieldLoss(
                recommend_activity,
                '推荐活动字段recommend_activity异常',
                {
                  response: response.data,
                },
            )
          ) {
            // eslint-disable-next-line camelcase
            this.recommend_activity = recommend_activity
          }

          if (
            !isSentryMainFieldLoss(timeline, '即将上线课程timeline字段异常', {
              response: response.data,
            })
          ) {
            this.timeline = timeline
          }

          if (
            !isSentryMainFieldLoss(new_season, '新课推荐new_season字段异常', {
              response: response.data,
            })
          ) {
            // eslint-disable-next-line camelcase
            this.cheeseResource = new_season.cards || []
            this.cheeseTitle = new_season.title && new_season.title.slice(0, 5)
            // eslint-disable-next-line camelcase
            this.cheeseResourceId = new_season ?
              new_season.resource_id + '' :
              ''
          }

          if (
            !isSentryMainFieldLoss(
                boutique_season,
                '精选推荐boutique_season字段异常',
                {
                  response: response.data,
                },
            )
          ) {
            this.jingxuanResource = boutique_season.cards || []
            // eslint-disable-next-line camelcase
            this.jingxuanResourceId = boutique_season ?
              boutique_season.resource_id :
              ''
            this.jingxuanTitle =
              boutique_season.title && boutique_season.title.slice(0, 5)
          }

          this.cooperationLink = data.cooperation.link || ''

          if (
            !isSentryMainFieldLoss(
                classification_list,
                '即将上线课程timeline字段异常',
                {
                  response: response.data,
                },
            )
          ) {
            // eslint-disable-next-line camelcase
            this.resource = classification_list
          }
          if (
            !isSentryMainFieldLoss(more_season, '更多好课more_season字段异常', {
              response: response.data,
            })
          ) {
            this.moreSeasonResource = more_season.cards || [] // eslint-disable-next-line camelcase
            this.moreSeasonResourceId = more_season ?
              more_season.resource_id :
              ''
            this.moreSeasonTitle =
              more_season.title && more_season.title.slice(0, 5)
          }
        }
      })
    },
    // 关键接口字段上报
    mainFieldReport() {
      isSentryMainFieldLoss(this.$store.state.banners, 'benner字段异常', {
        info: { ...this.$store.state.bannersErrorInfo },
      })
    },
  },
}
</script>

<style lang="less">
@import "./styles/common.less";
* {
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
    Arial, PingFang SC, Hiragino Sans GB, Microsoft YaHei, sans-serif;
}

.classroom-wrapper {
  width: 100%;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
}

.classroom-innerWrapper {
  width: 1286px;
  margin: 0 auto;
  padding-bottom: 1px;
  position: relative;
}

.classroom-rec {
  display: flex;
}

.classroom-rec-content {
  width: 854px !important;
  // padding-right: 10px;
  margin-right: 20px;
  // .block-list-content {
  //     flex-wrap: wrap;
  //     flex-direction: column;
  //     height: 400px;
  // }
}

@media screen and (max-width: 1438px) {
  .classroom-innerWrapper {
    width: 1070px;
  }

  .classroom-rec-content {
    width: 638px !important;
  }

  .block-list-detail {
    width: 638px;
    overflow: hidden;
  }
}
</style>
